import { DataDropdown } from "capitalrx-components-2.0/lib/forms";
import { useRemoteTableDataSource } from "capitalrx-components-2.0/lib/general";

import { getApiBaseUrl } from "@/api";
import { FormElementBaseProps, ProcedureCode } from "@/api/interfaces";
import { useCallback } from "react";


export const ProcedureCodeDropdown = ({
  name = "procedure_code",
  label = "Procedure Code (CPT or HCPCS)",
  required = false,
  disabled = false,
}: FormElementBaseProps) => {
  const apiBaseUrl = getApiBaseUrl();

  const maxLength = 100;
  const procedureCodeLabelProvider = useCallback((row: ProcedureCode.ProcedureCodeResult) => {
    const procedureCodeLongDescription = row.procedure_code.long_description;
    const longDescription = procedureCodeLongDescription.length > maxLength ? procedureCodeLongDescription.slice(0, maxLength) + "..." : procedureCodeLongDescription;
    return `${row.procedure_code.code} - ${longDescription}`;
  }, []);

  const dataSource = useRemoteTableDataSource<ProcedureCode.ProcedureCodeResult>(
    `${apiBaseUrl}/procedure_code/list`,
    (row) => row.procedure_code.code,
    {
      pageSize: 15,
      idFilterName: "code",
      authTokenRequired: false,
    },
  );

  return (
    <DataDropdown.Field
      dataSource={dataSource}
      optionLabelProvider={procedureCodeLabelProvider}
      label={label}
      name={name}
      searchField="code_or_description"
      required={required}
      disabled={disabled}
    />
  );
};
